import styled from 'styled-components';

export const ButtonContainer = styled.button`
text-transform:capitalize;
font-size: 1.4rem;
background:transparent;
border: 0.05rem solid var(--mainBlue);
border-color: ${props =>
        props.cart ? "var(--mainBlue)" : "var(--lightBlue)"}};
color: var(--mainblue);
border-radius: 0.5rem;
padding: 0.2rem 0.5rem;
curser: pointer;
margin:0.2rem 0.5rem 0.2rem 0;
transition: all 0.5s ease-in-out;
&:hover{
    background: var(--mainWhite);
    color: var(--mainGrey);
}
&:focus{
    outline:none;
}
`;